var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-content",on:{"click":_vm.onClick}},[_c('div',{staticClass:"box-back"},[(_vm.isChoosed)?_c('div',{staticClass:"box-block"}):_vm._e()]),_vm._v("\n  "+_vm._s(_vm.changeChecked)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b1c192","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckBox.vue
// module id = null
// module chunks = 